import { render, staticRenderFns } from "./VideoWidget.vue?vue&type=template&id=a1c62646&"
import script from "./VideoWidget.vue?vue&type=script&lang=js&"
export * from "./VideoWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports